import { SortableList } from "@octopusdeploy/design-system-components";
import type { TagSetResource, TagSetScope } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { SupportedTagSetScopes } from "~/components/MultiSelect/TagSetScopeMultiSelect";
import { repository } from "../../../../clientInstance";
import SaveDialogLayout from "../../../../components/DialogLayout/SaveDialogLayout";
interface TagSetsSorterProps {
    onSaved(): void;
}
interface TagSetsSorterState extends DataBaseComponentState {
    sortedTagSets: TagSetResource[];
}
export default class TagSetsSorter extends DataBaseComponent<TagSetsSorterProps, TagSetsSorterState> {
    constructor(props: TagSetsSorterProps) {
        super(props);
        this.state = { sortedTagSets: [] };
    }
    async componentDidMount() {
        return this.doBusyTask(async () => {
            const scopes: TagSetScope[] = isFeatureToggleEnabled("extended-tag-sets") ? SupportedTagSetScopes : ["Tenant"];
            this.setState({ sortedTagSets: await repository.TagSets.getAllByScopes(scopes) });
        });
    }
    render() {
        return (<SaveDialogLayout title="Reorder Tag Sets" errors={this.errors} busy={this.state.busy} onSaveClick={this.saveNewOrder}>
                <SortableList items={this.state.sortedTagSets} onItemsUpdated={(sortedTagSets: TagSetResource[]) => this.setState({ sortedTagSets })}/>
            </SaveDialogLayout>);
    }
    private saveNewOrder = async () => {
        return this.doBusyTask(async () => {
            await repository.TagSets.sort(this.state.sortedTagSets.map((i) => i.Id));
            this.props.onSaved();
        });
    };
    static displayName = "TagSetsSorter";
}
